import styled, { css } from 'styled-components';
import { strictSpace } from '../../utils';
import Text from '../Text/Text';
import { screenReaderOnly } from '../Mixins/Mixins';
export var ChoicePadContainer = styled.label.withConfig({
  displayName: "ChoicePadstyles__ChoicePadContainer",
  componentId: "sc-1da9swk-0"
})(["position:relative;margin:", ";padding:", " ", ";border-radius:0.5em;background-color:", ";box-sizing:border-box;cursor:pointer;font-family:", ";user-select:none;display:flex;align-items:", ";justify-content:space-around;flex-direction:column;flex-grow:1;flex-shrink:1;", " ", " ", " &::before{position:absolute;content:'';width:100%;height:100%;top:0;left:0;z-index:0;opacity:0;transition:opacity 0.3s;}&:hover:not(:disabled)::before{background-color:", ";}&:focus-within{box-shadow:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.xxs;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.s;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.m;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.bgActionSecondary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamilies.inter;
}, function (_ref6) {
  var inputPosition = _ref6.inputPosition;
  return inputPosition === 'left' ? 'flex-start' : 'center';
}, strictSpace, function (_ref7) {
  var checked = _ref7.checked;
  return checked && css(["background-color:", ";p{color:", ";}"], function (_ref8) {
    var checkedColor = _ref8.checkedColor,
        theme = _ref8.theme;
    return checkedColor || theme.colors.bgTargetSecondary;
  }, function (_ref9) {
    var disabled = _ref9.disabled,
        checked = _ref9.checked,
        theme = _ref9.theme;
    return disabled ? theme.colors.textDisabled : checked ? theme.colors.textActionTertiary : theme.colors.textPrimary;
  });
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled && css(["cursor:not-allowed;"]);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.bgHoverSecondary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.shadows.input;
});
export var ChoiceIcon = styled.div.withConfig({
  displayName: "ChoicePadstyles__ChoiceIcon",
  componentId: "sc-1da9swk-1"
})(["display:block;height:", ";width:", ";background:url('", "');background-repeat:no-repeat;background-position:center;background-size:contain;margin-left:auto;margin-right:auto;", " ", ""], function (_ref13) {
  var height = _ref13.height;
  return height;
}, function (_ref14) {
  var width = _ref14.width;
  return width;
}, function (_ref15) {
  var backgroundUrl = _ref15.backgroundUrl;
  return backgroundUrl;
}, strictSpace, function (_ref16) {
  var disabled = _ref16.disabled;
  return disabled && css(["opacity:0.5;"]);
});
export var ChoiceText = styled(Text).withConfig({
  displayName: "ChoicePadstyles__ChoiceText",
  componentId: "sc-1da9swk-2"
})(["width:100%;text-align:center;color:", ";", ";"], function (_ref17) {
  var disabled = _ref17.disabled,
      checked = _ref17.checked,
      theme = _ref17.theme;
  return disabled ? theme.colors.textDisabled : checked ? theme.colors.textActionTertiary : theme.colors.textPrimary;
}, function (props) {
  return props.srOnly && screenReaderOnly;
});
export var ChoiceInputPositioner = styled.div.withConfig({
  displayName: "ChoicePadstyles__ChoiceInputPositioner",
  componentId: "sc-1da9swk-3"
})(["", " position:absolute;", ";"], function (_ref18) {
  var hidden = _ref18.hidden;
  return hidden && css(["", ""], screenReaderOnly);
}, function (_ref19) {
  var inputPosition = _ref19.inputPosition;
  return inputPosition === 'left' ? css(["transform:translateY(-50%);top:50%;left:0.5em;"]) : css(["top:0.5em;right:0.5em;"]);
});
export var HiddenRadioInput = styled.input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "ChoicePadstyles__HiddenRadioInput",
  componentId: "sc-1da9swk-4"
})(["", ""], screenReaderOnly);